<template>
  <b-card>
    <b-row>
      <b-col>
        <b-form-group id="name-gr" label="نام:" label-for="name">
          <b-form-input id="name" v-model="detail.name" required placeholder="نام"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="code-gr" label="کد:" label-for="code">
          <b-form-input id="code" v-model="detail.code" required placeholder="کد"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="parent_id-gr" label="والد:" label-for="parent_id">
          <b-form-select v-model="detail.parent_id" :options="parents"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group id="Type-gr" label="انواع تفضیلی:" label-for="Type">
          <MDMulty v-bind:group="94" v-model="detail.mdid94_types"></MDMulty>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-checkbox v-model="detail.is_from_shepa">از طریق کاربران شپا</b-form-checkbox>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <b-form-group id="mdid98_source-gr" label="منبع:" label-for="mdid98_source">
          <MDDropdown v-bind:group="98" v-model="detail.mdid98_source"></MDDropdown>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="shepa_fkid-gr" label="شناسه یکتا در شپا:" label-for="shepa_fkid">
          <b-form-input
            id="shepa_fkid"
            v-model="detail.shepa_fkid"
            required
            placeholder="شناسه یکتا در شپا"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button variant="success" @click="save">ذخیره</b-button>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import MDDropdown from "../../../components/MDDropdown";
import MDMulty from "../../../components/MDMulty";
import httpHelper from "../../../helpers/httpHelper";
export default {
  name: "AccDetail",
  components: {
    MDDropdown,
    MDMulty
  },
  data() {
    return {
      detail: {
        name: "",
        mdid94_types: [],
        code: "",
        parent_id: "",
        is_from_shepa: false,
        mdid98_source: null,
        shepa_fkid: ""
      },
      parents:[]
    };
  },
  created() {
    if (this.$route.params.id) {
      httpHelper.getData("accdetail?id=" + this.$route.params.id).then(res => {
        this.detail = res.result;
        this.detail.is_from_shepa = this.detail.is_from_shepa == 1;
        this.detail.mdid94_types = [];
        this.detail.detail_types.forEach(element => {
          this.detail.mdid94_types.push(element.mdid94_type);
        });
        console.log(this.detail);
      });
    }
    httpHelper.getData("accdetail").then(res => {
      console.log(res);
      this.parents = res.result.map(element=>{
          return {
              text:element.name,
              value:element.id
          }
      });
    });
  },
  methods: {
    save() {
      console.log(this.detail);
      httpHelper.postData("accdetail", this.detail).then(res => {
        this.$router.push("/rp/17");
      });
    }
  }
};
</script>